import classes from './TrackerBadge.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  counter: number
  icon?: ReactNode
  variant: 'filter' | 'tag'
}

const TrackerBadge = ({
  counter,
  icon,
  variant
}: Props) => {
  const leadingSymbol = variant !== 'filter'
    ? '+'
    : ''

  return (
    <span className={classes.TrackerBadge + ' ' + classes[variant]}>
      <span>
        {leadingSymbol}
        {
          !icon &&
          counter
        }
        {icon}
      </span>
    </span>
  )
}

export default TrackerBadge
